import { styled } from '@mui/system';
import Theme from '../../Themes/main.theme';
import {StepIconProps} from '@mui/material';
const StepIconRoot = styled('div')<{
    ownerState: { completed?: boolean; active?: boolean };
  }>(({ ownerState }) => ({
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
      backgroundColor: Theme.ekomeColor?.main,
      boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    }),
    ...(ownerState.completed && {
      backgroundColor: Theme.ekomeColor?.main,
    }),
  }));
export default function StepIcon(props: StepIconProps) {
  const { active, icon } = props;
  return (
    <StepIconRoot ownerState={{ active }}>
      {icon}
    </StepIconRoot>
  );
}
  